import { render } from "./stock_logs.vue?vue&type=template&id=60e02520"
import script from "./stock_logs.vue?vue&type=script&lang=js"
export * from "./stock_logs.vue?vue&type=script&lang=js"

import "./stock_logs.vue?vue&type=style&index=0&id=60e02520&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__